import React, { useEffect, useState } from 'react';
import { shape, string, instanceOf } from 'prop-types';
import queryString from 'query-string';
import { withRouter, matchPath } from 'react-router';
import { Map } from 'immutable';
import GeneralModal from '../GeneralModal';
import SuccessInfo from '../SuccessInfo';
import checkTokenService from '../../ajax/checkToken';
import { isLoggedIn } from '../../utils/cookieToken';

const EmployeeTokenModal = ({ location, _literals }) => {
	const [employTokenApproved, setEmployTokenApproved] = useState(false);
	const { pathname, search } = location;

	const ignoredPaths = ['/account/email/confirm'];

	function checkToken() {
		const query = queryString.parse(search);

		if (query.token) {
			checkTokenService(query.token)
				.then(() => {
					setEmployTokenApproved(true);
				});
		}
	}

	useEffect(() => {
		const query = queryString.parse(search);

		if (!query.token || ignoredPaths.includes(pathname)) return;

		if (isLoggedIn()) {
			checkToken();
		} else {
			const isLoginPage = matchPath(pathname, {
				path: '/',
				exact: true
			});

			if (isLoginPage) {
				checkToken();
			}
		}
	}, [pathname]);

	const handleClose = () => {
		setEmployTokenApproved(false);
	};

	return (
		<GeneralModal
			isModalOpen={employTokenApproved}
			onCloseModal={handleClose}
			modalContentClassName='general-modal__body_add-employer-modal'
		>
			<SuccessInfo
				text={(_literals.employee_added_successfully || {}).literalValue}
				handleClose={handleClose}
			/>
		</GeneralModal>
	);
};

EmployeeTokenModal.propTypes = {
	location: shape({
		search: string.isRequired,
		pathname: string.isRequired
	}).isRequired,
	_literals: instanceOf(Map).isRequired
};

export default withRouter(EmployeeTokenModal);
